import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FQAN_razina, Razina } from '@app/components';
import {
  DokItemInfo,
  DokType
} from '@app/components/dokumentacija/dokumentacija-types';
import { AppUser, AuthService } from '@app/components/login.component';
import {
  ActionComponent,
  FilterView,
  FilterViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { map, tap, withLatestFrom } from 'rxjs';
import { PremjestiDokJedinicuService } from './premjesti-dok-jedinicu.service';

@Component({
  selector: 'app-premjesti-dokument-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class PremjestiDokumentActionComponent
  extends ActionComponent
  implements OnInit, OnDestroy
{
  private selectedItem: any;
  private isClipboardEmpty = true;

  constructor(
    protected listViewProvider: ListViewProviderDirective<ListView>,
    protected premjestiDokJedinicuService: PremjestiDokJedinicuService,
    protected filterViewProviderDirective: FilterViewProviderDirective<FilterView>,
    protected notificationService: NotificationService,
    @Inject(AuthService)
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.listViewProvider.selectedItems$
        .pipe(
          tap((selected) => {
            if (!!selected && selected.length == 1) {
              this.selectedItem = selected[0];
            }
          })
        )
        .subscribe()
    );
    this.addSubscription(
      this.premjestiDokJedinicuService.clipboardJedinica$
        .pipe(
          tap((clipboardJedinica) => {
            this.isClipboardEmpty = !clipboardJedinica.item;
          })
        )
        .subscribe()
    );
  }

  protected override initDisabledObservable(): void {
    super.initDisabledObservable();
    this.isDisabled$ = this.listViewProvider.selectedItems$.pipe(
      withLatestFrom(this.authService.validUser$),
      map(([selectedItems, user]) => {
        return this.isDisabled(selectedItems, user);
      })
    );
  }

  private isDisabled(selectedItems: any[], user: AppUser): boolean {
    const singleItemSelected = selectedItems && selectedItems.length === 1;
    const item = singleItemSelected ? selectedItems[0] : null;
    const dokInfo = item ? new DokItemInfo(item) : null;
    return (
      !dokInfo ||
      dokInfo.locked ||
      this.isParentLockedFolder(dokInfo) ||
      (dokInfo.permission < 2 && !this.isZaduzenNaPredmetu(item, user))
    );
  }

  private isParentLockedFolder(dokInfo: DokItemInfo): boolean {
    const parent = dokInfo.parent;
    return !!parent && parent.dokType === DokType.FOLDER && parent.locked;
  }

  private isZaduzenNaPredmetu(item: any, user: AppUser): boolean {
    const razina = item[FQAN_razina];
    if (razina !== Razina.PREDMET) {
      return true;
    }
    const zaduzeniId = item['seup~predmet~zaduzen_za_predmet'] as number;
    return zaduzeniId === user.userId?.value;
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  override executeAction(event: any): void {
    if (this.isClipboardEmpty) {
      this.premjestiDokJedinicuService.cutJedinica(this.selectedItem);
      this.clearSelection();
    }
  }

  private clearSelection(): void {
    this.listViewProvider.refresh();
  }
}
